const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
  }),
  button: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.accent,
    '&:focus': {
      outline: 'none'
    },
    '&:hover': {
      backgroundColor: '#fd5622',
    }
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/components/devicesoftwarereleases/styles.js